<div class="apple-paginator">
  <div class="paginator-info">
    <span class="results-per-page">Aantal resultaten per pagina</span>
    <apple-multiselect
      [multiple]="false"
      [options]="pageSizeOptionsStrings"
      [ngModel]="pageSize.toString()"
      (ngModelChange)="onPageSizeChange($event)"
      placeholder="Selecteer aantal"
      class="page-size-select">
    </apple-multiselect>
  </div>
  
  <div class="paginator-range">
    <span>{{ getRangeLabel() }}</span>
  </div>
  
  <div class="paginator-navigation">
    <button 
      class="nav-button" 
      [disabled]="!hasPreviousPage()"
      (click)="previousPage()"
      aria-label="Vorige pagina"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="15,18 9,12 15,6"></polyline>
      </svg>
    </button>
    
    <button 
      class="nav-button" 
      [disabled]="!hasNextPage()"
      (click)="nextPage()"
      aria-label="Volgende pagina"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="9,6 15,12 9,18"></polyline>
      </svg>
    </button>
  </div>
</div>
